import actionTypes from '../actions/actionTypes';

export const INITIAL_STATE = {};

const clientsGroupSelectedSort = (state = INITIAL_STATE, { type, data }) => {
  switch (type) {
    case actionTypes.CLIENTS_INFINITE_LIST_STATS:
      return {
        ...state,
        [data.groupId]: data?.customerFilterParams?.sort,
      };

    default:
      return state;
  }
};

export default clientsGroupSelectedSort;
